import { PageHeader } from '@fukuri-admins/ui/common';

type Props = {
  /** クライアント名（会社名） */
  clientName: string;
};

/**
 * クライアント詳細ヘッダー Presentation
 *
 * - パンくずリスト：利用企業 > {clientName}
 */
export const ClientDetailHeaderPresentation: React.FC<Props> = ({ clientName }) => (
  <PageHeader
    variant='breadcrumb'
    breadcrumbItems={[{ label: '利用企業', href: '/clients' }, { label: clientName }]}
  />
);
